export {
  getProductByStyleColor,
  GetProductByStyleColorParams,
} from './getProductByStyleColor';
